import httpClient from './httpClient'

const END_POINT = '/api/notas'

const getAllNotas = () => httpClient.get(END_POINT)

export {

    getAllNotas

}